import { render, staticRenderFns } from "./companyArchives.vue?vue&type=template&id=0b7c9192&"
import script from "./companyArchives.vue?vue&type=script&lang=js&"
export * from "./companyArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports